/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

 import {Component} from 'vue-property-decorator'
 import AlarmSearchService from "./service/alarmSearchService"
 import BasicSearchPage from "../../../components/basicSearchPage/basicSearchPage";
 import override from "../../../dectorators/override";
 import { AlarmSearchDOI } from '../../alarmManage/alarmSearch/api/alarmSearchApi'
 
 @Component
 export default class AlarmSearch extends BasicSearchPage<AlarmSearchService, AlarmSearchDOI.RowDataI, AlarmSearchDOI.QueryRowDataParamsI> {
     @override
     renderHead(h) {
         return <div></div>
     }
     
     @override
     loadService () {
        this.service = new AlarmSearchService(this)
     }
     
 }
 